import { Link } from 'react-router-dom';

export default function Terms() {
  return (
    <div className="min-h-screen bg-gradient-to-b from-[#FFF8F0] via-[#FFE8F0] to-[#F5E8FF]">
      <div className="max-w-[600px] mx-auto px-4 py-8">
        {/* Header */}
        <div className="text-center mb-8">
          <div className="flex justify-center mb-4">
            <img
              src="https://static.readdy.ai/image/2ded901b8fb990e993c5117b32e5999e/f6b52d0828689e13d597e866faced30e.png"
              alt="ERAI Logo"
              className="w-16 h-16 rounded-full object-cover"
            />
          </div>
          <h1 className="text-2xl font-bold text-gray-800">利用規約</h1>
          <p className="text-sm text-gray-500 mt-1">最終更新日：2025年1月</p>
        </div>

        {/* Content */}
        <div className="bg-white rounded-2xl shadow-sm p-6 mb-4">
          <div className="space-y-6">
            {/* Introduction */}
            <section>
              <p className="text-sm text-gray-600 leading-relaxed">
                本利用規約（以下「本規約」）は、ERAI（えらい）（以下「本アプリ」）の利用条件を定めるものです。ユーザーの皆様には、本規約に同意いただいた上で本アプリをご利用いただきます。
              </p>
            </section>

            {/* 1. Agreement */}
            <section>
              <h2 className="text-base font-bold text-gray-800 mb-3 flex items-center">
                <span className="w-2 h-2 bg-pink-500 rounded-full mr-2" />
                1. 規約への同意
              </h2>
              <p className="text-sm text-gray-600 leading-relaxed">
                ユーザーは、本アプリをダウンロード、インストール、または使用することにより、本規約に同意したものとみなされます。本規約に同意いただけない場合は、本アプリをご利用いただけません。
              </p>
            </section>

            {/* 2. Service Description */}
            <section>
              <h2 className="text-base font-bold text-gray-800 mb-3 flex items-center">
                <span className="w-2 h-2 bg-pink-500 rounded-full mr-2" />
                2. サービス内容
              </h2>
              <p className="text-sm text-gray-600 leading-relaxed">
                本アプリは、AIによる肯定的な通知を提供し、ユーザーの気分や心の状態を記録する機能を提供します。有料プラン（ERAI Plus）では、追加機能をご利用いただけます。
              </p>
            </section>

            {/* 3. User Responsibilities */}
            <section>
              <h2 className="text-base font-bold text-gray-800 mb-3 flex items-center">
                <span className="w-2 h-2 bg-pink-500 rounded-full mr-2" />
                3. ユーザーの責任
              </h2>
              <ul className="space-y-2 text-sm text-gray-600 leading-relaxed">
                <li className="flex items-start">
                  <span className="mr-2">•</span>
                  <span>ユーザーは、本アプリを適切に使用する責任を負います</span>
                </li>
                <li className="flex items-start">
                  <span className="mr-2">•</span>
                  <span>不正な方法での利用や、他のユーザーに迷惑をかける行為は禁止されています</span>
                </li>
                <li className="flex items-start">
                  <span className="mr-2">•</span>
                  <span>アカウント情報の管理はユーザーの責任において行ってください</span>
                </li>
              </ul>
            </section>

            {/* 4. Subscription */}
            <section>
              <h2 className="text-base font-bold text-gray-800 mb-3 flex items-center">
                <span className="w-2 h-2 bg-pink-500 rounded-full mr-2" />
                4. サブスクリプション
              </h2>
              <div className="space-y-2 text-sm text-gray-600 leading-relaxed">
                <p>
                  有料プラン（ERAI Plus）は、Apple App Store経由で提供されます。料金、支払い条件、キャンセルポリシーは、Appleの利用規約に従います。
                </p>
                <p>
                  サブスクリプションは自動更新されます。解約はいつでも可能ですが、解約後も現在の請求期間終了まで機能をご利用いただけます。
                </p>
              </div>
            </section>

            {/* 5. Intellectual Property */}
            <section>
              <h2 className="text-base font-bold text-gray-800 mb-3 flex items-center">
                <span className="w-2 h-2 bg-pink-500 rounded-full mr-2" />
                5. 知的財産権
              </h2>
              <p className="text-sm text-gray-600 leading-relaxed">
                本アプリおよびそのコンテンツに関する知的財産権は、すべて当方に帰属します。ユーザーは、本アプリの個人的な使用目的でのみ利用することができます。
              </p>
            </section>

            {/* 6. Disclaimer */}
            <section>
              <h2 className="text-base font-bold text-gray-800 mb-3 flex items-center">
                <span className="w-2 h-2 bg-pink-500 rounded-full mr-2" />
                6. 免責事項
              </h2>
              <div className="space-y-2 text-sm text-gray-600 leading-relaxed">
                <p>
                  本アプリは「現状有姿」で提供されます。当方は、本アプリの正確性、完全性、有用性について保証しません。
                </p>
                <p>
                  本アプリは医療サービスではありません。医療的なアドバイスや診断、治療を提供するものではありません。
                </p>
                <p>
                  本アプリの利用により生じた損害について、当方は一切の責任を負いません。
                </p>
              </div>
            </section>

            {/* 7. Service Changes */}
            <section>
              <h2 className="text-base font-bold text-gray-800 mb-3 flex items-center">
                <span className="w-2 h-2 bg-pink-500 rounded-full mr-2" />
                7. サービスの変更・終了
              </h2>
              <p className="text-sm text-gray-600 leading-relaxed">
                当方は、事前の通知なく本アプリの内容を変更、または提供を終了することがあります。これにより生じた損害について、当方は責任を負いません。
              </p>
            </section>

            {/* 8. Terms Changes */}
            <section>
              <h2 className="text-base font-bold text-gray-800 mb-3 flex items-center">
                <span className="w-2 h-2 bg-pink-500 rounded-full mr-2" />
                8. 規約の変更
              </h2>
              <p className="text-sm text-gray-600 leading-relaxed">
                当方は、必要に応じて本規約を変更することがあります。変更後の規約は、本アプリ内またはウェブサイトに掲載された時点で効力を生じます。
              </p>
            </section>

            {/* 9. Governing Law */}
            <section>
              <h2 className="text-base font-bold text-gray-800 mb-3 flex items-center">
                <span className="w-2 h-2 bg-pink-500 rounded-full mr-2" />
                9. 準拠法
              </h2>
              <p className="text-sm text-gray-600 leading-relaxed">
                本規約は日本法に準拠し、解釈されるものとします。
              </p>
            </section>

            {/* 10. Contact */}
            <section>
              <h2 className="text-base font-bold text-gray-800 mb-3 flex items-center">
                <span className="w-2 h-2 bg-pink-500 rounded-full mr-2" />
                10. お問い合わせ
              </h2>
              <p className="text-sm text-gray-600 leading-relaxed mb-2">
                本規約に関するご質問やご不明な点がございましたら、以下までお問い合わせください。
              </p>
              <a
                href="mailto:poznan9320@gmail.com"
                className="text-sm text-[#5B9BD5] font-medium hover:underline"
              >
                poznan9320@gmail.com
              </a>
            </section>
          </div>
        </div>

        {/* Back Button */}
        <div className="mb-4">
          <Link
            to="/support"
            className="flex items-center justify-center bg-white rounded-2xl shadow-sm p-4 hover:bg-gray-50 transition-colors cursor-pointer"
          >
            <i className="ri-arrow-left-line text-lg text-gray-600 mr-2" />
            <span className="text-sm font-medium text-gray-700">サポートページに戻る</span>
          </Link>
        </div>

        {/* Footer */}
        <div className="text-center py-6">
          <p className="text-xs text-gray-400">© 2025 ERAI</p>
          <p className="text-xs text-gray-400 mt-1">Made with 💙</p>
        </div>
      </div>
    </div>
  );
}